import { Label } from './style';
import CloudI from '../../assets/icons/cloud.svg?react';

const CloudUpload = () => {
  return (
    <Label>
      <CloudI />
      <h4>Upload from Cloud storage</h4>
      <p>PDF, XLS or CSV. Max size of 12MB</p>
    </Label>
  );
};

export default CloudUpload;
